export { default } from './FocusTrap';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Unstable_TrapFocus/index.js
// module id = 510
// module chunks = 25